import { Backbuttons } from './buttons';
import { useLocation,Link } from 'react-router';
const Bredcrum = ({ title }) =>{
//    const location = useLocation();
   let location = useLocation();
   const pathname = location.pathname || '';  // Ensure it's a string

  // Extract page name using split, with a fallback to 'Home'
  const pageName = title != '' ? title : (pathname.split('/').pop() || 'Home');

  const capitalizeFirstLetter = (str) => {
    if (!str) return ''; // Handle empty strings
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

   return(
    <>
        <div className='flex-box flex-between'>
            <p style={{color:'#783c3c',fontWeight:500}}>
              {/* <Link to={'/'}><i className='fa fa-home' style={{color:'#783c3c'}}></i></Link>&nbsp;&nbsp;&nbsp; */}
            {capitalizeFirstLetter(pageName)}</p> <Backbuttons/>
        </div> 
    </>
   );   
}

export default Bredcrum;